import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

import { Heading } from 'Components/_theme'

interface OrderSummaryHeadingRowProps {
  isOrganisation: boolean
  isNewOrder?: boolean
}

export const OrderSummaryHeadingRow = (props: OrderSummaryHeadingRowProps) => {
  const { isNewOrder, isOrganisation } = props

  return (
    <Row className="order-container grey-container p-2 px-4 d-flex justify-content-between align-items-center">
      <Col className="ps-0" xs={isNewOrder ? 6 : 8}>
        <Heading as={6} size={3}>
          <FormattedMessage id="NewOrderSummary_device" />
        </Heading>
      </Col>

      <Col className="text-end" xs={2}>
        <Heading as={6} size={3}>
          <FormattedMessage id="NewOrderSummary_rental_duration" />
        </Heading>
      </Col>

      {isNewOrder && isOrganisation && (
        <Col className="text-end" xs={2}>
          <Heading as={6} size={3}>
            <FormattedMessage id="NewOrderSummary_quantity" />
          </Heading>
        </Col>
      )}

      <Col className="text-end pe-0" xs={2}>
        <Heading as={6} size={3}>
          <FormattedMessage id="NewOrderSummary_price" />
        </Heading>
      </Col>
    </Row>
  )
}
